<template>
  <div class="submit-time">
    <el-checkbox v-model="content.checked" @change="handlerCheckbox"></el-checkbox>
    <div class="serial-label">
      <span class="text-medium leading-22 ml-8 mr-3 text-theme-black-650">提交时间</span>
    </div>
    <el-select v-model="value" size="small" class="bg-white-input mr-3" style="width:312px">
      <el-option v-for="o in options" :key="o.value" :value="o.value" :label="o.label" />
    </el-select>
  </div>
</template>

<script>
import { pad } from '@/assets/js/utils.js'

export default {
  name: 'SubmitTime',
  props: {
    content: Object
  },
  data() {
    return {
      value: '',
      options: [
        {
          label: '年',
          value: '0',
          getFormatValue() {
            let d = new Date()
            return d.getFullYear()
          }
        },
        {
          label: '年月',
          value: '1',
          getFormatValue() {
            let d = new Date()
            return d.getFullYear() + '' + pad(d.getMonth() + 1)
          }
        },
        {
          label: '年月日',
          value: '2',
          getFormatValue() {
            let d = new Date()
            return d.getFullYear() + '' + pad(d.getMonth() + 1) + '' + pad(d.getDate())
          }
        },
        {
          label: '年月日时分秒',
          value: '3',
          getFormatValue() {
            let d = new Date()
            let ymd = d.getFullYear() + '' + pad(d.getMonth() + 1) + '' + pad(d.getDate())
            let hms = pad(d.getHours()) + '' + pad(d.getMinutes()) + '' + pad(d.getSeconds())
            return ymd + hms
          }
        }
      ]
    }
  },
  methods: {
    getValue() {
      return this.value
    },
    setDefaultValue() {
      this.value = '2'
    },
    setValue(val) {
      this.value = val
    },
    handlerCheckbox(val) {
      if(val) {
        let o = this.options.find(o => o.value === this.value)
        this.$emit('format-change', o.getFormatValue())
      } else {
        this.$emit('format-change', '')
      }
    }
  },
  created() {
    if (this.content.defaultValue) {
      this.setValue(this.content.defaultValue)
    } else {
      this.setDefaultValue()
    }
  },
  watch: {
    value(v) {
      let o = this.options.find(o => o.value === v)
      if(this.content.checked) {
        this.$emit('format-change', o.getFormatValue())
      } else {
        this.$emit('format-change', '')
      }
      this.$emit('set-defaultValue', this.content.name, v)
    }
  }
}
</script>

<style scoped></style>
